<template>
  <div class="can-use-coupons">
    <div class="coupon-wrapper" v-show="canUseCoupons.length">
      <list
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
        v-model="loading"
      >
        <coupon-list
          :list="canUseCoupons"
          @activate-handler="activateHandler"
          @change="change"
          @overdue-handler="overdueHandler"
        ></coupon-list>
      </list>
    </div>
    <no-data v-show="noData" />
    <dialogs
      :showCancel="currentCoupon.rule_code === 'cardpasswd' ? false : true"
      :cancel-text="'再想想'"
      :confrim-text="currentCoupon.apply_btn"
      :show-msg="false"
      @cancel-handler="cancelHandler"
      @confrim-handler="confirmHandler"
      btn-round
      v-show="activationState"
    >
      <div class="coupon-desc">
        <div v-html="currentCoupon.content2"></div>
      </div>
    </dialogs>
    <popup class="coupon-model" close-on-popstate v-model="activationStatus">
      <div class="suc-desc">
        <button @click="closeHandler" class="close">
          <img alt src="../../assets/img/coupon-center/icon-close.png" />
        </button>
        <div class="title">
          <img alt src="../../assets/img/coupon-center/icon-suc.png" />
          <span>激活成功</span>
        </div>
        <p class="desc" v-html="currentCoupon.content4"></p>
        <div class="view-card">
          <button @click="viewCardHandler" class="view-card-btn">
            {{ currentCoupon.apply_after_btn }}
          </button>
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
// 可使用卡券
import { List, Popup } from 'vant'
import CouponList from './CouponList'
import Dialogs from '../../components/Dialog'
import NoData from './NoData'
import dayjs from 'dayjs'
// import api from '../../utils/api'
let flag = false
export default {
  name: 'can-use-coupon',
  components: {
    List,
    CouponList,
    Popup,
    Dialogs,
    NoData
  },
  data () {
    return {
      loading: false,
      finished: false,
      pageNum: 1,
      canUseCoupons: [],
      noData: false,
      activationState: false,
      activationStatus: false,
      currentCoupon: {
        apply_btn: '激活'
      },
      currentCouponSkus: []

    }
  },
  created () {
    this.$toast.loading('正在加载...')
    this.getCanUseCoupons()
  },
  methods: {
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getCanUseCoupons(++this.pageNum).then(() => {
          setTimeout(() => {
            flag = false
            this.loading = false
          }, 500)
        }, 300)
      })
    },

    // 取消激活
    cancelHandler () {
      this.activationState = false
    },

    /**
     * 确认激活
     * 折扣券 zhekouquan
     * sku 兑换券 voucher
     * 话费金兑换券 huafeijin
     * 福利金兑换券 gouwujin
     * 会员兑换券 freemember
     */
    async confirmHandler () {
      if (this.currentCoupon.rule_code === 'cardpasswd') {
        this.activationState = false
        return false
      }
      if (flag) {
        return false
      }
      flag = true
      this.$toast.loading('请稍后')
      let status = false

      // 直接兑换类
      const directExchangeClass = ['huafeijin', 'gouwujin', 'freemember']

      // sku兑换券
      const skuExchangeClass = ['voucher']

      if (directExchangeClass.includes(this.currentCoupon.rule_code)) {
        status = await this.activate({ pid: this.currentCoupon.prod_id, pno: this.currentCoupon.pickup_no })
      } else if (skuExchangeClass.includes(this.currentCoupon.rule_code)) {
        const skuList = this.currentCoupon.affix_sku_id.split(',')
        const scene = this.currentCoupon.scene
        if (skuList.length === 1) {
          const params = {
            pid: this.currentCoupon.prod_id,
            pno: this.currentCoupon.pickup_no,
            sku_id: skuList.join('')
          }
          if (scene === 1) {
            status = await this.activate(params)
          } else if (scene === 2) {
            status = await this.localLifeActivate(params)
          }
        }
      }
      if (status) {
        this.activationState = false
        this.overdueHandler(this.currentCoupon.pickup_no)
        this.activationStatus = true
        this.$toast.clear()
      } else {
        this.activationState = false
        // console.log('我先执行了')
      }
      flag = false
    },

    // 关闭弹窗
    closeHandler () {
      this.activationStatus = false
    },

    //  激活成功弹窗 按钮
    async viewCardHandler () {
      // this.$router.push({ name: 'myCardVoucher' })
      if (this.currentCoupon.jump_url) {
        location.href = this.currentCoupon.jump_url
        // if (this.currentCoupon.scene === 2) {
        //   const code = await api.getTokenCode()
        //   if (!code) {
        //     return false
        //   }
        //   location.href =  `${process.env.VUE_APP_SHOP_DOMAIN}getCode?tk=${code}&callback=${encodeURIComponent(this.currentCoupon.jump_url)}`
        // } else {
        // location.href = this.currentCoupon.jump_url
        // }

        this.closeHandler()
      } else {
        this.closeHandler()
      }
    },

    // 激活卡券回调函数
    async activateHandler (coupon) {
      // 激活类卡券 activation  跳转外链类卡券 jump
      if (coupon.rule_type === 'activation') {
        this.currentCoupon = coupon
        this.activationState = true
      } else if (coupon.rule_type === 'jump') {
        location.href = coupon.jump_receive_url
      }
    },

    // 激活
    async activate (params) {
      const res = await this.$axios.post('api/coupon/apply', params)
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },

    // 本地生活激活
    async localLifeActivate (params) {
      const res = await this.$http.post('customer/api/center/product/apply', params)
      if (res.status === 200) {
        const { error, msg } = res.data
        if (error === 0) {
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },

    // 过期卡券列表过滤
    overdueHandler (pickupNo) {
      // console.log(pickupNo)
      this.canUseCoupons = this.canUseCoupons.filter(v => v.pickup_no / pickupNo !== 1)
      // console.log(this.canUseCoupons.length, 'legnth')
      if (!this.canUseCoupons.length) {
        this.noData = true
      }
    },

    // 卡券可以使用回调
    change (pickupNo) {
      // console.log(pid)
      this.canUseCoupons = this.canUseCoupons.map(v => {
        if (v.pickupNo / pickupNo === 1) {
          v.couponStatus = 0
        }
        return v
      })
    },

    /**
   * 获取卡券关联skuid
   * @param{ * } pid  卡券id
   */
    async getCouponSkus (pid) {
      this.currentCouponSkus = []
      const res = await this.$axios.post('api/coupon/sku', { pid })
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          data.forEach(v => {
            this.currentCouponSkus.push(v.sku_id)
          })
          return true
        } else {
          this.$toast(msg)
          return false
        }
      }
    },

    /**
   * 获取可使用卡券
   */
    async getCanUseCoupons (pageNum) {
      const res = await this.$axios.get(`api/coupon/effective/${pageNum || 1}`)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          // let i = 1
          const list = data.data.map(v => {
            // v.effective_at
            const surTime = dayjs().diff(dayjs(v.effective_at), 'ss')
            if (surTime > 0) {
              v.couponStatus = 0 // 可激活
              // v.expire_at = '2020-4-8 10:21:00'
              // console.log(v.pickup_no, i++)
            } else {
              v.couponStatus = -1 // 暂不可激活
              // v.effective_at = '2020-4-8 10:21:00'
            }
            return v
          })
          this.canUseCoupons = [...this.canUseCoupons, ...list]
        } else if (code === 9006) {
          this.finished = true
          if (pageNum === 1 || !pageNum) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.coupon-list {
  .coupon-details {
    position: relative;
    padding: 0.24rem;
    margin-top: 0.2rem;
    background-color: #fff;
    .coupon-intro {
      display: flex;
      align-items: center;
    }
    .coupon-img {
      width: 2rem;
      height: 1.4rem;
      margin-right: 0.2rem;
      img {
        object-fit: contain;
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
      }
    }
    .coupon-desc {
      position: relative;
      width: 4.4rem;
      height: 1.4rem;
      .flex-column-between;
      .name {
        font-size: @fz26;
        color: @base;
      }
      .time {
        font-size: @fz22;
        color: #6f6f6f;
      }
      .activation {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 1.2rem;
        height: 0.64rem;
        font-size: @fz28;
        color: #fff;
        background: linear-gradient(
          90deg,
          rgba(255, 147, 147, 1) 0%,
          rgba(255, 90, 90, 1) 100%
        );
        box-shadow: 0px 0.1rem 0.05rem -0.08rem rgba(255, 203, 203, 1);
        border-radius: 32px;
      }
    }
    .coupon-tips {
      position: relative;
      margin-top: 0.3rem;
      font-size: @fz22;
      color: #a8a8a8;
      border-top: 0.5px dotted #c9c9c9;
      padding-top: 0.22rem;
      padding-left: 0.2rem;
      text-align: left;
      &::after,
      &::before {
        content: "";
        position: absolute;
        width: 0.25rem;
        height: 0.25rem;
        background-color: #f6f6f6;
        border-radius: 50%;
        top: -0.125rem;
      }
      &::after {
        left: -0.35rem;
      }
      &::before {
        right: -0.35rem;
      }
    }
    .coupon-status {
      position: absolute;
      right: 0.15rem;
      bottom: 0.6rem;
      width: 1.57rem;
      height: 1.18rem;
    }
    .status-overdue {
      background: url("../../assets/img/coupon-center/overdue.png") center
        no-repeat;
      background-size: 100%;
    }
    .status-used {
      background: url("../../assets/img/coupon-center/used.png") center
        no-repeat;
      background-size: 100%;
    }
  }
}
.coupon-desc {
  padding: 0.5rem 0.3rem 0.4rem;
  // text-align: center;
  line-height: 1.6;
}
.coupon-model {
  background-color: transparent;
  .suc-desc {
    position: relative;
    width: 6.1rem;
    background-color: #fff;
    border-radius: 0.14rem;
    .close {
      position: absolute;
      right: 0;
      top: 0;
      width: 0.48rem;
      height: 0.48rem;
    }
    .title {
      padding: 0.64rem 0 0.54rem;
      font-size: @fz32;
      color: @base;
      .flex-center;
      img {
        width: 0.48rem;
        height: 0.48rem;
        padding-right: 0.2rem;
      }
    }
    .desc {
      font-size: @fz26;
      color: @c80;
      padding: 0 0.5rem;
    }
    .view-card {
      padding: 0.4rem 0 0.1rem;
      text-align: center;
      .view-card-btn {
        width: 5.5rem;
        height: 0.8rem;
        font-size: @fz26;
        color: #fff;
        background-color: #ff4b28;
        border-radius: 30px;
      }
    }
  }
}
</style>
